export default "__VITE_ASSET__BdYsXxZb__"